import { IconCube, IconCubeSolid } from '@smartbear/swagger-portal-component-library'

import { ApiSubNavItem } from '../ApiSubNavItem'
import { API_TYPE, Schema } from '~/portal/types/content'

export const ApiSubNavSchema = ({
  parentPath,
  schema,
  active = false,
  isSelected,
  setSelectedSchema,
  onClick,
  apiType
}: {
  parentPath: string,
  schema: Schema,
  active?: boolean,
  isSelected: boolean,
  setSelectedSchema: (selectedSchema: string | null) => void,
  onClick?: (e) => void,
  apiType?: API_TYPE
}) => {
  const schemaIdentifier = apiType === API_TYPE.ASYNCAPI ? (schema.name || schema?.title) || '' : schema?.title || schema.name
  const schemaHash = apiType === API_TYPE.ASYNCAPI ? `#/schema-${encodeURIComponent(schemaIdentifier)}` : `#/${encodeURIComponent(schemaIdentifier)}`

  return (
    <ApiSubNavItem
      parentPath={parentPath}
      identifier={schemaIdentifier}
      hash={schemaHash}
      icon={<IconCube />}
      activeIcon={<IconCubeSolid />}
      active={active}
      isSelected={isSelected}
      setSelectedItem={setSelectedSchema}
      onClick={onClick}
    />
  )
}